import React, { useState } from "react";

import { ChangePhoto } from "../../utils/Constant";
import MUIIcons from "../MUIIcon/MUIIcons";

import { ImageUploadModal } from "./ImageUploadModal";
import "./ProfileImageUpload.scss";

interface ProfileImageUploadProps {
  currentImage?: string;
  onImageChange?: (file: File) => void;
  showEdit?: boolean;
  handleImageUpload?: any;
}

export const ProfileImageUpload: React.FC<ProfileImageUploadProps> = ({
  currentImage,
  onImageChange,
  showEdit = false,
  handleImageUpload = () => {
    return;
  },
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleImageUpdate = (file: File) => {
    onImageChange?.(file);
  };

  const onAllUpload = async () => {
    await handleImageUpload();
    setIsModalOpen(false);
  };

  return (
    <div className="profile-image-upload">
      <div
        className="profile-image-container"
        onClick={() => {
          if (showEdit) setIsModalOpen(true);
        }}
      >
        {currentImage ? (
          <img src={currentImage} alt="Profile" className="profile-image" />
        ) : (
          <div className="profile-image-placeholder">
            <MUIIcons iconName="CameraAltOutlined" size={24} />
          </div>
        )}
        {showEdit && (
          <div className="profile-image-overlay">
            <MUIIcons iconName="CameraAltOutlined" size={24} />
            <span>{ChangePhoto}</span>
          </div>
        )}
      </div>

      {isModalOpen && (
        <ImageUploadModal
          onClose={() => {
            onImageChange(null);
            setIsModalOpen(false);
          }}
          onImageSelect={handleImageUpdate}
          currentImage={currentImage}
          handleImageUpload={onAllUpload}
        />
      )}
    </div>
  );
};
